// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaTrash, FaPlus, FaMinus } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import AddressModal from "./AddressModal";
// import PaymentOptions from "./PaymentOptions";
// import Swal from "sweetalert2";
// import CartSkeleton from "./CartSkeleton";

// const AllCartProduct = () => {
//   const [cartProducts, setCartProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [userAddress, setUserAddress] = useState(null);
//   const [showAddressModal, setShowAddressModal] = useState(false);
//   const [showPaymentOptions, setShowPaymentOptions] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);
//   const [isPlacingOrder, setIsPlacingOrder] = useState(false);
//   const [gstNumber, setGstNumber] = useState(""); // New state for GST number
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const userDataString = localStorage.getItem("BricksNbar-Users-Data");
//     if (userDataString) {
//       setUserData(JSON.parse(userDataString));
//     }
//   }, []);

//   useEffect(() => {
//     if (userData?._id) {
//       getAllCartProducts();
//     }
//   }, [userData]);

//   useEffect(() => {
//     if (selectedPayment === "Razorpay" && paymentId && userAddress) {
//       handlePlaceOrder();
//     }
//   }, [selectedPayment, paymentId]);

//   const getAllCartProducts = async () => {
//     setIsLoading(true);
//     const userId = userData?._id;

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${userId}`
//       );
//       setCartProducts(
//         response?.data?.items?.filter((item) => item.product !== null) || []
//       );
//     } catch (error) {
//       console.error("Error fetching cart products:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const getProductPrice = (product, selectedSize = null) => {
//     if (!product) return 0;

//     if (product.sizeType === "multiple" && product.multipleSizes?.length > 0) {
//       if (selectedSize) {
//         const size = product.multipleSizes.find((s) => s.size === selectedSize);
//         return size ? size.price : product.multipleSizes[0].price;
//       }
//       return product.multipleSizes[0].price;
//     } else if (product.sizeType === "one" && product.singleSize) {
//       return product.singleSize.price;
//     }
//     return 0;
//   };

//   const handleQuantityChange = (productId, selectedSize, newQuantity) => {
//     if (newQuantity < 1) return;

//     setCartProducts((prevProducts) =>
//       prevProducts.map((item) =>
//         item?.product?._id === productId && item?.selectedSize === selectedSize
//           ? { ...item, quantity: newQuantity }
//           : item
//       )
//     );
//   };

//   const handleRemoveItem = async (productId, selectedSize) => {
//     Swal.fire({
//       title: "Are you sure to delete this product?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const userId = userData?._id;

//           const url = selectedSize
//             ? `${process.env.REACT_APP_API_URL}/cart/remove-cart-item?userId=${userId}&productId=${productId}&selectedSize=${selectedSize}`
//             : `${process.env.REACT_APP_API_URL}/cart/remove-cart-item?userId=${userId}&productId=${productId}`;

//           await axios.delete(url);

//           setCartProducts((prevProducts) =>
//             prevProducts.filter(
//               (item) =>
//                 !(
//                   item?.product?._id === productId &&
//                   item?.selectedSize === selectedSize
//                 )
//             )
//           );

//           Swal.fire({
//             title: "Deleted!",
//             text: "The product has been removed from your cart.",
//             icon: "success",
//           }).then(() => {
//             window.location.reload();
//           });
//         } catch (error) {
//           console.error("Error removing product from cart:", error);
//           Swal.fire({
//             title: "Error!",
//             text: "Something went wrong. Please try again.",
//             icon: "error",
//           });
//         }
//       }
//     });
//   };

//   const calculateSubTotal = () =>
//     cartProducts.reduce(
//       (total, item) =>
//         total +
//         getProductPrice(item?.product, item?.selectedSize) * item?.quantity,
//       0
//     );

//   const calculateGstTax = () => {
//     return cartProducts.reduce(
//       (total, item) =>
//         total +
//         ((getProductPrice(item?.product, item?.selectedSize) *
//           item?.product?.gstPercentage) /
//           100) *
//           item?.quantity,
//       0
//     );
//   };

//   const calculateExtraTax = () => {
//     return cartProducts.reduce(
//       (total, item) =>
//         total +
//         ((getProductPrice(item?.product, item?.selectedSize) *
//           item?.product?.extraTaxPercentage) /
//           100) *
//           item?.quantity,
//       0
//     );
//   };

//   const calculateActualShippingCharge = () => {
//     return cartProducts.reduce(
//       (total, item) => total + item?.product?.shippingCharge * item?.quantity,
//       0
//     );
//   };

//   // New function to calculate conditional delivery charge
//   const calculateDeliveryCharge = () => {
//     const subTotal = calculateSubTotal();
//     const actualShippingCharge = calculateActualShippingCharge();

//     // If subtotal is >= 5000, delivery is free (0)
//     // Otherwise, apply the actual shipping charge
//     return subTotal >= 5000 ? 0 : actualShippingCharge;
//   };

//   const subTotal = calculateSubTotal();
//   const gstTax = calculateGstTax();
//   const extraTax = calculateExtraTax();
//   const actualShippingCharge = calculateActualShippingCharge();
//   const deliveryCharge = calculateDeliveryCharge();
//   const gstPriceIncluding = subTotal + gstTax;
//   const totalPrice = subTotal + gstTax + extraTax + deliveryCharge;

//   const handleCheckout = () => {
//     setShowAddressModal(true);
//   };

//   const handleSelectAddress = (address) => {
//     setUserAddress(address);
//     setShowAddressModal(false);
//   };

//   const handleShowPaymentOptions = () => {
//     setShowPaymentOptions(true);
//   };

//   const handleSelectPayment = (method, payment_id = null) => {
//     setSelectedPayment(method);
//     if (payment_id) {
//       setPaymentId(payment_id);
//     }
//     setShowPaymentOptions(false);
//   };

//   const handlePlaceOrder = async () => {
//     if (!userAddress || !selectedPayment) {
//       Swal.fire({
//         title: "Incomplete Information",
//         text: "Please select both delivery address and payment method",
//         icon: "warning",
//       });
//       return;
//     }

//     setIsPlacingOrder(true);

//     try {
//       const orderData = {
//         userId: userData?._id,
//         shippingAddress: userAddress?._id || userAddress?.id,
//         products: cartProducts.map((item) => ({
//           product: item?.product?._id,
//           quantity: item?.quantity,
//           size: item?.selectedSize,
//         })),
//       };

//       // Add GST number to order data if provided
//       if (gstNumber.trim()) {
//         orderData.gstNumber = gstNumber.trim();
//       }

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/orders/place-order`,
//         orderData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data) {
//         try {
//           await axios.delete(
//             `${process.env.REACT_APP_API_URL}/cart/clear-cart?userId=${userData?._id}`
//           );
//         } catch (error) {
//           console.error("Error clearing cart:", error);
//         }

//         Swal.fire({
//           title: "Order Placed Successfully!",
//           text:
//             selectedPayment === "Razorpay"
//               ? "Your payment was successful and order has been placed."
//               : "Your order has been placed. You will pay on delivery.",
//           icon: "success",
//         }).then(() => {
//           setCartProducts([]);
//           setGstNumber(""); // Clear GST number after successful order
//           navigate("/orders");
//         });
//       }
//     } catch (error) {
//       console.error("Error placing order:", error);
//       Swal.fire({
//         title: "Order Failed",
//         text: "There was a problem placing your order. Please try again.",
//         icon: "error",
//       });
//     } finally {
//       setIsPlacingOrder(false);
//     }
//   };

//   // GST number validation function
//   const validateGstNumber = (gst) => {
//     const gstRegex =
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
//     return gstRegex.test(gst);
//   };

//   const handleGstNumberChange = (e) => {
//     const value = e.target.value.toUpperCase();
//     setGstNumber(value);
//   };

//   if (isLoading) {
//     return <CartSkeleton />;
//   }

//   if (cartProducts.length === 0) {
//     return (
//       <div className="container mx-auto p-4">
//         <div className="flex flex-col items-center justify-center h-64">
//           <h2 className="text-2xl font-bold text-red-700">
//             Your Cart is Empty
//           </h2>
//           <p className="mt-2 text-gray-600">
//             Add some products to start shopping
//           </p>
//           <button
//             className="mt-6 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//             onClick={() => navigate("/products")}
//           >
//             Add Products To Cart
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const getActionButtonText = () => {
//     if (!userAddress) return "Checkout";
//     if (!selectedPayment) return "Select Payment Method";
//     return "Place Order";
//   };

//   const handleActionButtonClick = () => {
//     if (!userAddress) return handleCheckout();
//     if (!selectedPayment) return handleShowPaymentOptions();
//     return handlePlaceOrder();
//   };

//   return (
//     <div className="container mx-auto p-4">
//       {/* Header Section with Shopping Cart Title and GST Field */}
//       <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-6">
//         <div className="flex-shrink-0">
//           <h1 className="text-2xl font-bold text-red-800">Shopping Cart</h1>
//         </div>

//         {/* GST Number Field */}
//         <div className="lg:max-w-md bg-gradient-to-r from-red-50 to-orange-50 rounded-lg shadow-sm border border-red-100">
//           <div className="relative">
//             <input
//               type="text"
//               id="gstNumber"
//               value={gstNumber}
//               onChange={handleGstNumberChange}
//               placeholder="Enter GST Number"
//               className="w-full px-3 py-2 border-2 border-red-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors bg-white text-sm"
//               maxLength={15}
//             />
//             {gstNumber && (
//               <button
//                 onClick={() => setGstNumber("")}
//                 className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
//               >
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             )}
//           </div>

//           {gstNumber && !validateGstNumber(gstNumber) && (
//             <div className="flex items-center gap-2 mt-2">
//               <svg
//                 className="w-3 h-3 text-red-500"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               <p className="text-red-500 text-xs">Invalid GST format</p>
//             </div>
//           )}
//           {gstNumber && validateGstNumber(gstNumber) && (
//             <div className="flex items-center gap-2 mt-2">
//               <svg
//                 className="w-3 h-3 text-green-500"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               <p className="text-green-600 text-xs font-medium">
//                 Valid GST number
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-6">
//         <div className="lg:w-2/3">
//           <div className="bg-white rounded-lg shadow-md">
//             {cartProducts.map((item) => {
//               const unitPrice = getProductPrice(
//                 item?.product,
//                 item?.selectedSize
//               );
//               const totalPrice = unitPrice * item?.quantity;

//               return (
//                 <div
//                   key={`${item?.product?._id}-${
//                     item?.selectedSize || "single"
//                   }`}
//                   className="border-b last:border-b-0 p-4"
//                 >
//                   <div className="flex flex-col md:flex-row gap-4">
//                     <div className="md:w-1/4">
//                       <img
//                         src={item?.product?.images[0]}
//                         alt={item?.product?.name}
//                         className="w-full h-32 object-cover rounded-md"
//                       />
//                     </div>
//                     <div className="md:w-3/4 flex flex-col justify-between">
//                       <div>
//                         <div className="flex justify-start items-center gap-3">
//                           <h3 className="font-semibold text-lg capitalize">
//                             {item?.product?.name}
//                           </h3>
//                           <h3 className="font-semibold text-lg capitalize">
//                             {item?.product?.measurement
//                               ? `(${item.product.measurement})`
//                               : ""}
//                           </h3>
//                         </div>
//                         {item?.selectedSize && (
//                           <h3 className="font-semibold text-md capitalize text-gray-500">
//                             Size: {item?.selectedSize}
//                           </h3>
//                         )}
//                         <div className="flex items-center pt-1 gap-3">
//                           <p className="font-semibold tracking-wide">
//                             ₹{totalPrice.toFixed(2)}
//                             <span className="text-sm text-gray-500 ml-1">
//                               ({item?.quantity} × ₹{unitPrice.toFixed(2)})
//                             </span>
//                           </p>
//                         </div>
//                         {item?.product?.stock_status === "out of stock" && (
//                           <p className="text-red-600 text-sm mt-1 font-semibold">
//                             Out of Stock
//                           </p>
//                         )}
//                       </div>

//                       <div className="flex justify-between items-center mt-4">
//                         <div className="flex items-center border border-gray-300 rounded-md">
//                           <button
//                             className="px-3 py-1 text-gray-600 hover:bg-gray-100"
//                             onClick={() =>
//                               handleQuantityChange(
//                                 item?.product?._id,
//                                 item?.selectedSize,
//                                 item?.quantity - 1
//                               )
//                             }
//                           >
//                             <FaMinus size={12} />
//                           </button>
//                           <span className="px-3 py-1 border-x border-gray-300">
//                             {item?.quantity}
//                           </span>
//                           <button
//                             className="px-3 py-1 text-gray-600 hover:bg-gray-100"
//                             onClick={() =>
//                               handleQuantityChange(
//                                 item?.product?._id,
//                                 item?.selectedSize,
//                                 item?.quantity + 1
//                               )
//                             }
//                           >
//                             <FaPlus size={12} />
//                           </button>
//                         </div>

//                         <div className="flex items-center gap-4">
//                           <button
//                             className="text-red-600 hover:text-red-800"
//                             onClick={() =>
//                               handleRemoveItem(
//                                 item?.product?._id,
//                                 item?.selectedSize
//                               )
//                             }
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="mt-4">
//             <button
//               className="text-red-700 font-semibold hover:text-red-800 flex items-center gap-1"
//               onClick={() => navigate("/products")}
//             >
//               <FaPlus size={12} /> Add More Products
//             </button>
//           </div>
//         </div>

//         <div className="lg:w-1/3">
//           <div className="bg-white rounded-lg shadow-md p-6">
//             <h2 className="text-xl font-bold mb-4">Price Details</h2>

//             <div className="space-y-3">
//               <div className="flex justify-between">
//                 <span className="text-gray-600">SubTotal</span>
//                 <span>₹{subTotal.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">GST</span>
//                 <span>₹{gstTax.toFixed(2)}</span>
//               </div>

//               <div className="border-t border-dashed border-gray-300 my-2 pt-2">
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Price Including GST</span>
//                   <span>₹{gstPriceIncluding.toFixed(2)}</span>
//                 </div>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-600">Extra Tax</span>
//                 <span>₹{extraTax.toFixed(2)}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span className="text-gray-600">Delivery Fee</span>
//                 <span
//                   className={
//                     deliveryCharge === 0 ? "text-green-600 font-semibold" : ""
//                   }
//                 >
//                   {deliveryCharge === 0
//                     ? "Free"
//                     : `₹${deliveryCharge.toFixed(2)}`}
//                 </span>
//               </div>

//               <div className="border-t border-dashed border-gray-300 my-2 pt-2">
//                 <div className="flex justify-between font-bold">
//                   <span>Total Amount</span>
//                   <span className="text-red-700">₹{totalPrice.toFixed(2)}</span>
//                 </div>
//               </div>
//             </div>

//             <button
//               className="w-full mt-6 bg-red-600 text-white py-3 rounded-lg font-bold hover:bg-red-700 transition-colors"
//               onClick={handleActionButtonClick}
//               disabled={isPlacingOrder}
//             >
//               {isPlacingOrder ? (
//                 <span className="flex items-center justify-center">
//                   <span className="animate-spin h-5 w-5 mr-3 border-2 border-white border-t-transparent rounded-full"></span>
//                   Processing...
//                 </span>
//               ) : (
//                 getActionButtonText()
//               )}
//             </button>

//             {userAddress && (
//               <div className="mt-4 p-3 bg-gray-50 rounded-md">
//                 <h3 className="font-semibold mb-1">Delivery Address</h3>
//                 <p className="text-sm text-gray-600">{userAddress.fullName}</p>
//                 <p className="text-sm text-gray-600">
//                   {userAddress.addressLine1}
//                   {userAddress.addressLine2 && `, ${userAddress.addressLine2}`}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   {userAddress.city} - {userAddress.postalCode}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   {userAddress.state}, {userAddress.country}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   Mobile: {userAddress.phone}
//                 </p>
//                 <button
//                   className="text-red-600 text-sm mt-2 hover:text-red-800"
//                   onClick={() => setShowAddressModal(true)}
//                 >
//                   Change
//                 </button>
//               </div>
//             )}

//             {selectedPayment && (
//               <div className="mt-4 p-3 bg-gray-50 rounded-md">
//                 <h3 className="font-semibold mb-1">Payment Method</h3>
//                 <p className="text-sm text-gray-600">
//                   {selectedPayment === "COD" ? "Cash On Delivery" : "Razorpay"}
//                 </p>
//                 <button
//                   className="text-red-600 text-sm mt-2 hover:text-red-800"
//                   onClick={() => setShowPaymentOptions(true)}
//                 >
//                   Change
//                 </button>
//               </div>
//             )}

//             {/* GST Number Display */}
//             {gstNumber && (
//               <div className="mt-4 p-3 bg-gradient-to-r from-red-50 to-orange-50 rounded-lg border border-red-200">
//                 <div className="flex items-center justify-between mb-2">
//                   <div className="flex items-center gap-2">
//                     <svg
//                       className="w-4 h-4 text-red-600"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                       />
//                     </svg>
//                     <h3 className="font-semibold text-red-800">GST Number</h3>
//                   </div>
//                   <button
//                     className="text-red-600 hover:text-red-800 text-sm font-medium"
//                     onClick={() => setGstNumber("")}
//                   >
//                     Remove
//                   </button>
//                 </div>
//                 <p className="text-sm text-gray-700 font-mono bg-white px-2 py-1 rounded border">
//                   {gstNumber}
//                 </p>
//                 <p className="text-xs text-green-600 mt-1">
//                   ✓ Business invoice will be generated
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <AddressModal
//         isOpen={showAddressModal}
//         onClose={() => setShowAddressModal(false)}
//         onSelectAddress={handleSelectAddress}
//       />

//       <PaymentOptions
//         total={totalPrice}
//         isOpen={showPaymentOptions}
//         onClose={() => setShowPaymentOptions(false)}
//         onSelectPayment={handleSelectPayment}
//       />
//     </div>
//   );
// };

// export default AllCartProduct;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaTrash, FaPlus, FaMinus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AddressModal from "./AddressModal";
import PaymentOptions from "./PaymentOptions";
import Swal from "sweetalert2";
import CartSkeleton from "./CartSkeleton";

const AllCartProduct = () => {
  const [cartProducts, setCartProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userAddress, setUserAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const userDataString = localStorage.getItem("BricksNbar-Users-Data");
    if (userDataString) {
      setUserData(JSON.parse(userDataString));
    }
  }, []);

  useEffect(() => {
    if (userData?._id) {
      getAllCartProducts();
    }
  }, [userData]);

  useEffect(() => {
    if (selectedPayment === "Razorpay" && paymentId && userAddress) {
      handlePlaceOrder();
    }
  }, [selectedPayment, paymentId]);

  const getAllCartProducts = async () => {
    setIsLoading(true);
    const userId = userData?._id;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${userId}`
      );
      setCartProducts(
        response?.data?.items?.filter((item) => item.product !== null) || []
      );
    } catch (error) {
      console.error("Error fetching cart products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getProductPrice = (product, selectedSize = null) => {
    if (!product) return 0;

    if (product.sizeType === "multiple" && product.multipleSizes?.length > 0) {
      if (selectedSize) {
        const size = product.multipleSizes.find((s) => s.size === selectedSize);
        return size ? size.price : product.multipleSizes[0].price;
      }
      return product.multipleSizes[0].price;
    } else if (product.sizeType === "one" && product.singleSize) {
      return product.singleSize.price;
    }
    return 0;
  };

  // New function to get previous price for discount calculation
  const getProductPreviousPrice = (product, selectedSize = null) => {
    if (!product) return 0;

    if (product.sizeType === "multiple" && product.multipleSizes?.length > 0) {
      if (selectedSize) {
        const size = product.multipleSizes.find((s) => s.size === selectedSize);
        return size?.previous_price || size?.price || 0;
      }
      return (
        product.multipleSizes[0]?.previous_price ||
        product.multipleSizes[0]?.price ||
        0
      );
    } else if (product.sizeType === "one" && product.singleSize) {
      return (
        product.singleSize?.previous_price || product.singleSize?.price || 0
      );
    }
    return 0;
  };

  // Calculate total discount amount
  const calculateTotalDiscount = () => {
    return cartProducts.reduce((total, item) => {
      const currentPrice = getProductPrice(item?.product, item?.selectedSize);
      const previousPrice = getProductPreviousPrice(
        item?.product,
        item?.selectedSize
      );
      const discountPerItem = previousPrice - currentPrice;
      return total + discountPerItem * item?.quantity;
    }, 0);
  };

  // Calculate original total (before discount)
  const calculateOriginalTotal = () => {
    return cartProducts.reduce((total, item) => {
      const previousPrice = getProductPreviousPrice(
        item?.product,
        item?.selectedSize
      );
      return total + previousPrice * item?.quantity;
    }, 0);
  };

  const handleQuantityChange = (productId, selectedSize, newQuantity) => {
    if (newQuantity < 1) return;

    setCartProducts((prevProducts) =>
      prevProducts.map((item) =>
        item?.product?._id === productId && item?.selectedSize === selectedSize
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  const handleRemoveItem = async (productId, selectedSize) => {
    Swal.fire({
      title: "Are you sure to delete this product?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const userId = userData?._id;

          const url = selectedSize
            ? `${process.env.REACT_APP_API_URL}/cart/remove-cart-item?userId=${userId}&productId=${productId}&selectedSize=${selectedSize}`
            : `${process.env.REACT_APP_API_URL}/cart/remove-cart-item?userId=${userId}&productId=${productId}`;

          await axios.delete(url);

          setCartProducts((prevProducts) =>
            prevProducts.filter(
              (item) =>
                !(
                  item?.product?._id === productId &&
                  item?.selectedSize === selectedSize
                )
            )
          );

          Swal.fire({
            title: "Deleted!",
            text: "The product has been removed from your cart.",
            icon: "success",
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          console.error("Error removing product from cart:", error);
          Swal.fire({
            title: "Error!",
            text: "Something went wrong. Please try again.",
            icon: "error",
          });
        }
      }
    });
  };

  const calculateSubTotal = () =>
    cartProducts.reduce(
      (total, item) =>
        total +
        getProductPrice(item?.product, item?.selectedSize) * item?.quantity,
      0
    );

  const calculateGstTax = () => {
    return cartProducts.reduce(
      (total, item) =>
        total +
        ((getProductPrice(item?.product, item?.selectedSize) *
          (item?.product?.gstPercentage || 0)) /
          100) *
          item?.quantity,
      0
    );
  };

  const calculateExtraTax = () => {
    return cartProducts.reduce(
      (total, item) =>
        total +
        ((getProductPrice(item?.product, item?.selectedSize) *
          (item?.product?.extraTaxPercentage || 0)) /
          100) *
          item?.quantity,
      0
    );
  };

  const calculateActualShippingCharge = () => {
    return cartProducts.reduce(
      (total, item) =>
        total + (item?.product?.shippingCharge || 0) * item?.quantity,
      0
    );
  };

  const calculateDeliveryCharge = () => {
    const subTotal = calculateSubTotal();
    const actualShippingCharge = calculateActualShippingCharge();
    return subTotal >= 5000 ? 0 : actualShippingCharge;
  };

  // Individual product tax calculations for display
  const getProductGstTax = (product, selectedSize, quantity) => {
    const price = getProductPrice(product, selectedSize);
    return ((price * (product?.gstPercentage || 0)) / 100) * quantity;
  };

  const getProductExtraTax = (product, selectedSize, quantity) => {
    const price = getProductPrice(product, selectedSize);
    return ((price * (product?.extraTaxPercentage || 0)) / 100) * quantity;
  };

  const subTotal = calculateSubTotal();
  const gstTax = calculateGstTax();
  const extraTax = calculateExtraTax();
  const actualShippingCharge = calculateActualShippingCharge();
  const deliveryCharge = calculateDeliveryCharge();
  const gstPriceIncluding = subTotal + gstTax;
  const totalPrice = subTotal + gstTax + extraTax + deliveryCharge;

  // Discount calculations
  const totalDiscount = calculateTotalDiscount();
  const originalTotal = calculateOriginalTotal();

  const handleCheckout = () => {
    setShowAddressModal(true);
  };

  const handleSelectAddress = (address) => {
    setUserAddress(address);
    setShowAddressModal(false);
  };

  const handleShowPaymentOptions = () => {
    setShowPaymentOptions(true);
  };

  const handleSelectPayment = (method, payment_id = null) => {
    setSelectedPayment(method);
    if (payment_id) {
      setPaymentId(payment_id);
    }
    setShowPaymentOptions(false);
  };

  const calculateTotalSavings = () => {
    let totalSavings = totalDiscount; // Product discounts

    // Add delivery savings if order is above 5000
    if (subTotal >= 5000 && actualShippingCharge > 0) {
      totalSavings += actualShippingCharge;
    }

    return totalSavings;
  };

  // Use this in your component calculation
  const totalSavingsAmount = calculateTotalSavings();

  const handlePlaceOrder = async () => {
    if (!userAddress || !selectedPayment) {
      Swal.fire({
        title: "Incomplete Information",
        text: "Please select both delivery address and payment method",
        icon: "warning",
      });
      return;
    }

    setIsPlacingOrder(true);

    try {
      const orderData = {
        userId: userData?._id,
        shippingAddress: userAddress?._id || userAddress?.id,
        products: cartProducts.map((item) => ({
          product: item?.product?._id,
          quantity: item?.quantity,
          size: item?.selectedSize,
        })),
      };

      if (gstNumber.trim()) {
        orderData.gstNumber = gstNumber.trim();
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/orders/place-order`,
        orderData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        try {
          await axios.delete(
            `${process.env.REACT_APP_API_URL}/cart/clear-cart?userId=${userData?._id}`
          );
        } catch (error) {
          console.error("Error clearing cart:", error);
        }

        Swal.fire({
          title: "Order Placed Successfully!",
          text:
            selectedPayment === "Razorpay"
              ? "Your payment was successful and order has been placed."
              : "Your order has been placed. You will pay on delivery.",
          icon: "success",
        }).then(() => {
          setCartProducts([]);
          setGstNumber("");
          navigate("/orders");
        });
      }
    } catch (error) {
      console.error("Error placing order:", error);
      Swal.fire({
        title: "Order Failed",
        text: "There was a problem placing your order. Please try again.",
        icon: "error",
      });
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const validateGstNumber = (gst) => {
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gst);
  };

  const handleGstNumberChange = (e) => {
    const value = e.target.value.toUpperCase();
    setGstNumber(value);
  };

  if (isLoading) {
    return <CartSkeleton />;
  }

  if (cartProducts.length === 0) {
    return (
      <div className="container mx-auto p-4">
        <div className="flex flex-col items-center justify-center h-64">
          <h2 className="text-2xl font-bold text-red-700">
            Your Cart is Empty
          </h2>
          <p className="mt-2 text-gray-600">
            Add some products to start shopping
          </p>
          <button
            className="mt-6 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            onClick={() => navigate("/products")}
          >
            Add Products To Cart
          </button>
        </div>
      </div>
    );
  }

  const getActionButtonText = () => {
    if (!userAddress) return "Checkout";
    if (!selectedPayment) return "Select Payment Method";
    return "Place Order";
  };

  const handleActionButtonClick = () => {
    if (!userAddress) return handleCheckout();
    if (!selectedPayment) return handleShowPaymentOptions();
    return handlePlaceOrder();
  };

  return (
    <div className="container mx-auto p-4">
      {/* Header Section with Shopping Cart Title and GST Field */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-6">
        <div className="flex-shrink-0">
          <h1 className="text-2xl font-bold text-red-800">Shopping Cart</h1>
        </div>

        {/* GST Number Field */}
        <div className="lg:max-w-md bg-gradient-to-r from-red-50 to-orange-50 rounded-lg shadow-sm border border-red-100">
          <div className="relative">
            <input
              type="text"
              id="gstNumber"
              value={gstNumber}
              onChange={handleGstNumberChange}
              placeholder="Enter GST Number"
              className="w-full px-3 py-2 border-2 border-red-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors bg-white text-sm"
              maxLength={15}
            />
            {gstNumber && (
              <button
                onClick={() => setGstNumber("")}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>

          {gstNumber && !validateGstNumber(gstNumber) && (
            <div className="flex items-center gap-2 mt-2">
              <svg
                className="w-3 h-3 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-red-500 text-xs">Invalid GST format</p>
            </div>
          )}
          {gstNumber && validateGstNumber(gstNumber) && (
            <div className="flex items-center gap-2 mt-2">
              <svg
                className="w-3 h-3 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-green-600 text-xs font-medium">
                Valid GST number
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-2/3">
          <div className="bg-white rounded-lg shadow-md">
            {cartProducts.map((item) => {
              const unitPrice = getProductPrice(
                item?.product,
                item?.selectedSize
              );
              const previousPrice = getProductPreviousPrice(
                item?.product,
                item?.selectedSize
              );
              const totalPrice = unitPrice * item?.quantity;
              const hasDiscount = previousPrice > unitPrice;
              const discountAmount =
                (previousPrice - unitPrice) * item?.quantity;

              // Individual product tax calculations
              const productGstTax = getProductGstTax(
                item?.product,
                item?.selectedSize,
                item?.quantity
              );
              const productExtraTax = getProductExtraTax(
                item?.product,
                item?.selectedSize,
                item?.quantity
              );

              return (
                <div
                  key={`${item?.product?._id}-${
                    item?.selectedSize || "single"
                  }`}
                  className="border-b last:border-b-0 p-4"
                >
                  <div className="flex flex-col md:flex-row gap-4">
                    <div className="md:w-1/4">
                      <img
                        src={item?.product?.images[0]}
                        alt={item?.product?.name}
                        className="w-full h-32 object-cover rounded-md"
                      />
                    </div>
                    <div className="md:w-3/4 flex flex-col justify-between">
                      <div>
                        <div className="flex justify-start items-center gap-3">
                          <h3 className="font-semibold text-lg capitalize">
                            {item?.product?.name}
                          </h3>
                          <h3 className="font-semibold text-lg capitalize">
                            {item?.product?.measurement
                              ? `(${item.product.measurement})`
                              : ""}
                          </h3>
                        </div>
                        {item?.selectedSize && (
                          <h3 className="font-semibold text-md capitalize text-gray-500">
                            Size: {item?.selectedSize}
                          </h3>
                        )}
                        <div className="flex items-center pt-1 gap-3">
                          <p className="font-semibold tracking-wide">
                            ₹{totalPrice.toFixed(2)}
                            <span className="text-sm text-gray-500 ml-1">
                              ({item?.quantity} × ₹{unitPrice.toFixed(2)})
                            </span>
                          </p>
                          {hasDiscount && (
                            <div className="flex items-center gap-2">
                              <span className="text-sm text-gray-500 line-through">
                                ₹{(previousPrice * item?.quantity).toFixed(2)}
                              </span>
                              <span className="text-sm bg-green-100 text-green-700 px-2 py-1 rounded-full font-medium">
                                Save ₹{discountAmount.toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>

                        {/* Individual Product Tax Display */}
                        <div className="mt-2 space-y-1">
                          {productGstTax > 0 && (
                            <div className="flex items-center gap-2 text-sm text-gray-600">
                              <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs">
                                GST {item?.product?.gstPercentage}%
                              </span>
                              <span>₹{productGstTax.toFixed(2)}</span>
                            </div>
                          )}
                          {productExtraTax > 0 && (
                            <div className="flex items-center gap-2 text-sm text-gray-600">
                              <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs">
                                Extra Tax {item?.product?.extraTaxPercentage}%
                              </span>
                              <span>₹{productExtraTax.toFixed(2)}</span>
                            </div>
                          )}
                        </div>

                        {item?.product?.stock_status === "out of stock" && (
                          <p className="text-red-600 text-sm mt-1 font-semibold">
                            Out of Stock
                          </p>
                        )}
                      </div>

                      <div className="flex justify-between items-center mt-4">
                        <div className="flex items-center border border-gray-300 rounded-md">
                          <button
                            className="px-3 py-1 text-gray-600 hover:bg-gray-100"
                            onClick={() =>
                              handleQuantityChange(
                                item?.product?._id,
                                item?.selectedSize,
                                item?.quantity - 1
                              )
                            }
                          >
                            <FaMinus size={12} />
                          </button>
                          <span className="px-3 py-1 border-x border-gray-300">
                            {item?.quantity}
                          </span>
                          <button
                            className="px-3 py-1 text-gray-600 hover:bg-gray-100"
                            onClick={() =>
                              handleQuantityChange(
                                item?.product?._id,
                                item?.selectedSize,
                                item?.quantity + 1
                              )
                            }
                          >
                            <FaPlus size={12} />
                          </button>
                        </div>

                        <div className="flex items-center gap-4">
                          <button
                            className="text-red-600 hover:text-red-800"
                            onClick={() =>
                              handleRemoveItem(
                                item?.product?._id,
                                item?.selectedSize
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-4">
            <button
              className="text-red-700 font-semibold hover:text-red-800 flex items-center gap-1"
              onClick={() => navigate("/products")}
            >
              <FaPlus size={12} /> Add More Products
            </button>
          </div>
        </div>

        <div className="lg:w-1/3">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4">Price Details</h2>

            <div className="space-y-3">
              {/* Show original total and discount if there are discounts */}
              {totalDiscount > 0 && (
                <>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Original Total</span>
                    <span className="line-through text-gray-500">
                      ₹{originalTotal.toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-600 font-medium">
                      Total Discount
                    </span>
                    <span className="text-green-600 font-medium">
                      -₹{totalDiscount.toFixed(2)}
                    </span>
                  </div>
                  <div className="border-t border-dashed border-gray-300 my-2 pt-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600 font-medium">
                        SubTotal (After Discount)
                      </span>
                      <span className="font-medium">
                        ₹{subTotal.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </>
              )}

              {/* Show normal subtotal if no discounts */}
              {totalDiscount === 0 && (
                <div className="flex justify-between">
                  <span className="text-gray-600">SubTotal</span>
                  <span>₹{subTotal.toFixed(2)}</span>
                </div>
              )}

              {/* Individual Tax Display */}
              {gstTax > 0 && (
                <div className="flex justify-between">
                  <span className="text-gray-600 flex items-center gap-2">
                    GST Tax
                    <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs">
                      {cartProducts.length > 0 &&
                      cartProducts.some((item) => item?.product?.gstPercentage)
                        ? `${Math.round(
                            cartProducts.reduce(
                              (acc, item) =>
                                acc + (item?.product?.gstPercentage || 0),
                              0
                            ) / cartProducts.length
                          )}% avg`
                        : "Various %"}
                    </span>
                  </span>
                  <span>₹{gstTax.toFixed(2)}</span>
                </div>
              )}

              {extraTax > 0 && (
                <div className="flex justify-between">
                  <span className="text-gray-600 flex items-center gap-2">
                    Extra Tax
                    <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-xs">
                      {cartProducts.length > 0 &&
                      cartProducts.some(
                        (item) => item?.product?.extraTaxPercentage
                      )
                        ? `${Math.round(
                            cartProducts.reduce(
                              (acc, item) =>
                                acc + (item?.product?.extraTaxPercentage || 0),
                              0
                            ) /
                              cartProducts.filter(
                                (item) => item?.product?.extraTaxPercentage
                              ).length || 1
                          )}% avg`
                        : "Various %"}
                    </span>
                  </span>
                  <span>₹{extraTax.toFixed(2)}</span>
                </div>
              )}

              <div className="border-t border-dashed border-gray-300 my-2 pt-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Price Including Taxes</span>
                  <span>₹{gstPriceIncluding.toFixed(2)}</span>
                </div>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Delivery Fee</span>
                <span
                  className={
                    deliveryCharge === 0 ? "text-green-600 font-semibold" : ""
                  }
                >
                  {deliveryCharge === 0
                    ? "Free"
                    : `₹${deliveryCharge.toFixed(2)}`}
                </span>
              </div>

              <div className="border-t border-dashed border-gray-300 my-2 pt-2">
                <div className="flex justify-between font-bold">
                  <span>Total Amount</span>
                  <span className="text-red-700">₹{totalPrice.toFixed(2)}</span>
                </div>
              </div>

              {/* Total Savings Summary */}
              {totalSavingsAmount > 0 && (
                <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
                  <div className="flex items-center justify-center gap-1">
                    🎉
                    <span className="text-green-700 font-semibold">
                      You saved ₹{totalSavingsAmount.toFixed(2)} on this order!
                    </span>
                  </div>

                  {/* Optional: Show breakdown of savings */}
                  <div className="mt-2 text-center">
                    <div className="text-xs text-green-600 space-y-1">
                      {totalDiscount > 0 && (
                        <div>
                          Product discounts: ₹{totalDiscount.toFixed(2)}
                        </div>
                      )}
                      {subTotal >= 5000 && actualShippingCharge > 0 && (
                        <div>
                          Free delivery saved: ₹
                          {actualShippingCharge.toFixed(2)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <button
              className="w-full mt-6 bg-red-600 text-white py-3 rounded-lg font-bold hover:bg-red-700 transition-colors"
              onClick={handleActionButtonClick}
              disabled={isPlacingOrder}
            >
              {isPlacingOrder ? (
                <span className="flex items-center justify-center">
                  <span className="animate-spin h-5 w-5 mr-3 border-2 border-white border-t-transparent rounded-full"></span>
                  Processing...
                </span>
              ) : (
                getActionButtonText()
              )}
            </button>

            {userAddress && (
              <div className="mt-4 p-3 bg-gray-50 rounded-md">
                <h3 className="font-semibold mb-1">Delivery Address</h3>
                <p className="text-sm text-gray-600">{userAddress.fullName}</p>
                <p className="text-sm text-gray-600">
                  {userAddress.addressLine1}
                  {userAddress.addressLine2 && `, ${userAddress.addressLine2}`}
                </p>
                <p className="text-sm text-gray-600">
                  {userAddress.city} - {userAddress.postalCode}
                </p>
                <p className="text-sm text-gray-600">
                  {userAddress.state}, {userAddress.country}
                </p>
                <p className="text-sm text-gray-600">
                  Mobile: {userAddress.phone}
                </p>
                <button
                  className="text-red-600 text-sm mt-2 hover:text-red-800"
                  onClick={() => setShowAddressModal(true)}
                >
                  Change
                </button>
              </div>
            )}

            {selectedPayment && (
              <div className="mt-4 p-3 bg-gray-50 rounded-md">
                <h3 className="font-semibold mb-1">Payment Method</h3>
                <p className="text-sm text-gray-600">
                  {selectedPayment === "COD" ? "Cash On Delivery" : "Razorpay"}
                </p>
                <button
                  className="text-red-600 text-sm mt-2 hover:text-red-800"
                  onClick={() => setShowPaymentOptions(true)}
                >
                  Change
                </button>
              </div>
            )}

            {/* GST Number Display */}
            {gstNumber && (
              <div className="mt-4 p-3 bg-gradient-to-r from-red-50 to-orange-50 rounded-lg border border-red-200">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <svg
                      className="w-4 h-4 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <h3 className="font-semibold text-red-800">GST Number</h3>
                  </div>
                  <button
                    className="text-red-600 hover:text-red-800 text-sm font-medium"
                    onClick={() => setGstNumber("")}
                  >
                    Remove
                  </button>
                </div>
                <p className="text-sm text-gray-700 font-mono bg-white px-2 py-1 rounded border">
                  {gstNumber}
                </p>
                <p className="text-xs text-green-600 mt-1">
                  ✓ Business invoice will be generated
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <AddressModal
        isOpen={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        onSelectAddress={handleSelectAddress}
      />

      <PaymentOptions
        total={totalPrice}
        isOpen={showPaymentOptions}
        onClose={() => setShowPaymentOptions(false)}
        onSelectPayment={handleSelectPayment}
      />
    </div>
  );
};

export default AllCartProduct;
